import * as THREE from 'three'
import LineCube from './Cubes/LineCube';
import PlaneCube from './Cubes/PlaneCube';

export default function DappModel(gridSize, node, textureManager)
{
    const size = gridSize * 0.25

    const geometry = new THREE.BoxGeometry(size + 0.01, size + 0.01, size + 0.01 );
    const material = new THREE.MeshBasicMaterial( {color: 0x00ff00} );
    const cube = new THREE.Mesh( geometry, material );
    material.transparent = true
    material.depthTest = false
    material.opacity = 0
    
    const planeCube = new PlaneCube(size, node, textureManager)
    cube.add(planeCube.cube)
    planeCube.show()
    planeCube.disableLogo()

    node.threeObject = cube
    node.edgePosition = new THREE.Object3D()
    cube.add(node.edgePosition)
    node.edgePosition.position.set(-size*0.5, size*0.5, -size*0.5)

    return cube
}